import { HandleCTAClick } from ".";

export const parseCTAs = (ctas: InboxCTA[], handleClick: HandleCTAClick) => {
    const filteredValidCTAs = ctas.filter(
        ({ article, url, type }) => type === "bridgeFunction" || article || url,
    );

    return filteredValidCTAs.map(
        ({
            id,
            label,
            type,
            article,
            url,
            variant,
            functionName,
            functionArgs,
        }) => {
            return {
                id,
                label,
                onClick: () =>
                    handleClick({
                        id,
                        type,
                        article,
                        url,
                        label,
                        functionName,
                        functionArgs,
                    }),
                variant,
            };
        },
    );
};
